/**
 * Shared FetchModal `className` overrides for LP-v2's public-facing modals — full-screen sheet on
 * mobile that becomes a centered card at `sm:`, vs. a compact auto-height card. Used by both
 * FormModal (form-fill/checkout vs. thank-you/recap) and HotelBookingModal (form vs. every other
 * phase) so the two don't hand-copy the same Tailwind strings.
 */

/** Full-bleed mobile sheet, centered `max-w-3xl` card at `sm:` and up — for the primary content phase. */
export const PUBLIC_MODAL_FULL_SCREEN_MOBILE_CLASSNAME =
  "m-0 h-dvh max-h-dvh w-screen rounded-none p-4 sm:my-8 sm:h-auto sm:max-h-[90vh] sm:w-full sm:max-w-3xl sm:rounded-3xl sm:p-6";

/** Small auto-height card — for lightweight phases (thank-you/recap, loading, error, confirmation). */
export const PUBLIC_MODAL_COMPACT_CLASSNAME =
  "m-4 max-h-[90vh] w-[calc(100vw-2rem)] max-w-lg rounded-3xl p-6 sm:my-8 sm:w-full";
